"use client";

import { createContext, type PropsWithChildren, useContext, useEffect } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import type { VideoCallingState, VideoCallingStore, VideoCallingStoreApi } from "../../stores/videoCallingStore";

const VideoCallingStoreContext = createContext<VideoCallingStoreApi | undefined>(undefined);

export const VideoCallingStoreProvider = ({ children, store }: PropsWithChildren<{ store: VideoCallingStoreApi }>) => {
  useEffect(() => {
    if (!store.persist.hasHydrated()) void store.persist.rehydrate();
  }, [store]);
  return <VideoCallingStoreContext.Provider value={store}>{children}</VideoCallingStoreContext.Provider>;
};

export const useVideoCallingStoreApi = () => {
  const store = useContext(VideoCallingStoreContext);
  if (!store) throw new Error("VideoCallingStoreProvider is not found");
  return store;
};

export const useVideoCallingState = (): VideoCallingState =>
  useStore(
    useVideoCallingStoreApi(),
    useShallow(
      ({ isOpenSubWindow, currentCounselingId, currentOtcScreeningId, isCheckedVideoCalling, isMoveSubWindow }) => ({
        isOpenSubWindow,
        currentCounselingId,
        currentOtcScreeningId,
        isCheckedVideoCalling,
        isMoveSubWindow,
      })
    )
  );

export const useVideoCallingStore = <T,>(selector: (state: VideoCallingStore) => T): T =>
  useStore(useVideoCallingStoreApi(), selector);
